import React from 'react';

function mapInstructions(){
  return (
    <div>
      <div className='instruction-content'>
        <p>Find cross-sections of the river that you find important and save them to your favorites to make them easy to access.</p>
      </div>
      <div className='instruction-section'>
        <h3>Legend</h3>
        <div className='instruction-content'>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>Use the legend to hide and display map layers.</p>
              <p><strong>Locations</strong> will display key locations along the Missouri River such as towns and cities.</p>
              <p><strong>Gages</strong> are located along the river and are connected to the National Weather Service.</p>
              <p><strong>River Sections</strong> - for the purposes of this EIS, the Missouri River north of Gavins Point is divided into three reaches that are modelled separately using HEC-RAS (HEC-RAS modeling has not been performed downstream of Gavins Point because flow differences between the alternatives are minimal).</p>
              <ul>
                <li>Fort Peck to Garrison Dam: begins with the regulated outflow from Fort Peck Dam in Montana and extends approximately 382 miles downstream, to just upstream of Garrison Dam on Lake Sakakawea, North Dakota.</li>
                <li>Garrison Dam to Oahe Dam: begins with the regulated outflow from Garrison Dam in North Dakota and extends approximately 318 miles downstream to just upstream of Oahe Dam on Lake Oahe, South Dakota.</li>
                <li>Fort Randall Dam to Gavins Point Dam: begins with the regulated outflow from Fort Randall Dam in South Dakota and extends 69 miles downstream to just upstream of Gavins Point Dam on Lewis and Clark Lake.</li>
              </ul>
              <p><strong>Dams</strong> layer contains dam location and some summary data.</p>
            </div>
            <img src='../../../images/map_legend.png' alt='Map Legend' width="400px"/>
          </div>
        </div>
      </div>
      <div className='instruction-section'>
        <h3>Cross Sections</h3>
        <div className='instruction-content'>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>Zooming in on a section of the river will expose cross-sections. Clicking on a cross-section will show information and allow you to open this location in a chart. Additionally, you can add the area to you favorites.</p>
            </div>
            <img src='../../../images/map_trans.png' alt='Map Transects' width="400px"/>
          </div>
        </div>
      </div>
      <div className='instruction-section'>
        <h3>Gages</h3>
        <div className='instruction-content'>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>There are numerous gages along the Missouri River which hold important flood level information. The Locations contain links to the National Weather Service.</p>
            </div>
            <img src='../../../images/map_gage.png' alt='Map Gages' width="400px"/>
          </div>
        </div>
      </div>
      <div className='instruction-section'>
        <h3>Dams</h3>
        <div className='instruction-content'>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>Clicking a dam icon will open an information window for the selected dam.</p>
            </div>
            <img src='../../../images/map_dam.png' alt='Map Dams' width="400px"/>
          </div>
        </div>
      </div>
      <div className='instruction-section'>
        <h3>Map Controls</h3>
        <div className='instruction-content'>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>Use the basemap toggle to switch between a vector and satellite map.</p>
            </div>
            <div style={{width: '400px'}}>
              <img src='../../../images/vector-map.png' alt='Vector Map' width="400px"/>
              <img src='../../../images/sat-map.png' alt='Satellite Map' width="400px"/>
            </div>
          </div>
          <div className='flex-align-top'>
            <div style={{marginRight: '10px'}}>
              <p>Use the zoom buttons to zoom in and out on the map.</p>
            </div>
            <img src='../../../images/zoom-map.png' alt='Zoom Map' width="400px"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default mapInstructions


// WEBPACK FOOTER //
// ./src/components/instructions/mapInstructions.js